import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

// Session storage keys used by HR FF Approval filters
const HR_FF_AGENCY_KEY = 'hr_ff_agency_filter';
const HR_FF_STATUS_KEY = 'hr_ff_status_filter';

/**
 * Tracks the current module (first path segment) in sessionStorage.
 * Clears module-specific cached filters when the user navigates
 * away from that module.
 *
 * Must be rendered inside <BrowserRouter>.
 */
const ModuleTracker = () => {
  const location = useLocation();
  const prevModuleRef = useRef(null);

  useEffect(() => {
    const currentModule = '/' + (location.pathname.split('/')[1] || '');
    const prevModule = prevModuleRef.current;

    // When leaving the HR module, clear cached filters
    if (
      prevModule &&
      prevModule.startsWith('/hr-manager') &&
      !currentModule.startsWith('/hr-manager')
    ) {
      sessionStorage.removeItem(HR_FF_AGENCY_KEY);
      sessionStorage.removeItem(HR_FF_STATUS_KEY);
    }

    prevModuleRef.current = currentModule;
    sessionStorage.setItem('app_current_module', currentModule);
  }, [location.pathname]);

  return null;
};

export default ModuleTracker;
